import serialize from 'form-serialize'
import Bus from './bus'

export function bus(target) {
  let orig = target.prototype.componentWillUnmount
  let map = new Map()
  // add bind method
  target.prototype.bind = function (event, name) {
    let self = this
    let fns = map.get(this) || []
    let cb = function() {
      let fn = target.prototype[name]
      if (!fn || typeof fn !== 'function') throw new Error(`function ${name} not found`)
      fn.apply(self, arguments)
    }
    Bus.on(event, cb)
    fns.push(function () {
      Bus.off(event, cb)
    })
    map.set(this, fns)
  }
  target.prototype.componentWillUnmount = function() {
    let fns = map.get(this) || []
    fns.forEach(fn => {
      fn()
    })
    map.delete(this)
    orig.apply(this, arguments)
  }
}

export function form(target) {
  let orig = target.prototype.onSubmit
  if (!orig) throw new Error('onSubmit method not found')
  target.prototype.onSubmit = function (event) {
    event.preventDefault()
    let obj = serialize(event.target, { hash: true })
    orig.call(this, event, obj)
  }
}

export function fields(arr) {
  return function (target) {
    for (let name of arr) {
      Object.defineProperty(target.prototype, name, {
        get: function() {
          return this.get(name)
        },
        set: function(val) {
          this.set(name, val)
        }
      })
    }
  }
}
